import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectStateService {

  // utilisateur dans un projet ?
  inProject$ = new BehaviorSubject<boolean>(false);

  // mode instantané ou structuré ?
  isInstantMode$ = new BehaviorSubject<boolean>(false);

  setInProject(value: boolean) {
    this.inProject$.next(value);
  }

  setInstantMode(value: boolean) {
    this.isInstantMode$.next(value);
  }
}
